import './cardSkeleton.scss';
import { Box, Skeleton, Stack } from '@mui/material';

export default function ProductCardSkeleton() {
  let skeletons = [];
  for (let i = 0; i < 5; i++) {
    skeletons.push(
      <Box className="product-card-skeleton" aria-label="product-card-skeleton">
        <Skeleton
          aria-label="skeleton-element"
          variant="rectangular"
          width={80}
          height={80}
          sx={{ minWidth: '80px' }}
        />
        <Stack className="skeleton-content" direction="column" spacing={1}>
          <Skeleton aria-label="skeleton-element" width="60%" height={14} />
          <Skeleton aria-label="skeleton-element" width="60%" height={14} />
          <Skeleton aria-label="skeleton-element" height={14} />
          <Skeleton aria-label="skeleton-element" height={14} />
        </Stack>
        <Stack direction="column" justifyContent="space-between" alignItems="flex-end" spacing={1}>
          <Skeleton aria-label="skeleton-element" width="60%" height={14} />
          <Skeleton
            aria-label="skeleton-element"
            width={93}
            height={38}
            sx={{ borderRadius: '20px' }}
          />
        </Stack>
      </Box>
    );
  }
  return skeletons.map((value, index) => {
    return (
      <Box aria-label="product-card-skeleton-wrapper" key={index}>
        {value}
      </Box>
    );
  });
}
